import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import SearchBar from './search-bar';
import Button from '../button/button';
import { useDebounce } from '@frontend/shared-utils';

const Search = ({
  onSearch = () => {},
  debounce = false,
  placeholder = '',
  styleType = 'default',
  className = '',
  defaultValue = '',
  showSearchButton = false,
}: {
  onSearch: (search: string) => void;
  debounce?: boolean;
  placeholder?: string;
  styleType?: 'default' | 'borderless';
  className?: string;
  defaultValue?: string;
  showSearchButton?: boolean;
}) => {
  const [mounted, setMounted] = useState(false);
  const [searchTerm, setSearchTerm] = useState(defaultValue);
  const debouncedSearchTerm = useDebounce(searchTerm, 600);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (debounce) {
      onSearch(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm, debounce]);

  useEffect(() => {
    if (mounted) {
      setSearchTerm(defaultValue);
    }
  }, [defaultValue]);

  return (
    <div
      data-cy="search-container"
      className={classNames('flex flex-row w-full h-10', className)}
    >
      <SearchBar
        queryString={defaultValue}
        styleType={styleType}
        onChange={setSearchTerm}
        placeholder={placeholder}
      />
      {(!debounce || showSearchButton) && (
        <div className="ml-2">
          <Button
            size="large"
            label="Search"
            onClick={() => onSearch(searchTerm)}
          />
        </div>
      )}
    </div>
  );
};

export default Search;
